import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments';
import { Observable } from 'rxjs';
import { ResponseApiDto } from '../DTOs/_response-api.dto';
import { LinkEntity } from '../entities/link.entitty';

@Injectable({
    providedIn: 'root',
})
export class LinkApi {
    private prefix = 'link';

    //* Injects
    private _httpClient = inject(HttpClient);

    /**
     * Get all links
     * @returns LinkEntity[]
     */
    public getAll(): Observable<ResponseApiDto<LinkEntity[]>> {
        try {
            const url = `${environment.API_BASE}${this.prefix}`;
            return this._httpClient.get<ResponseApiDto<LinkEntity[]>>(url);
        } catch (error) {
            throw error;
        }
    }
}
